module.exports = __webpack_public_path__ + "static/media/csv.a49eeac0.png";